var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blob)?_c('div',[_c('VueMarkdownWithAnchors',{staticClass:"text-left",attrs:{"source":_vm.blob}}),_vm._t("default")],2):_c('Loading')}
var staticRenderFns = []

export { render, staticRenderFns }